export default "__VITE_ASSET__DrYg6efc__"